
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const SimulatorPage = lazy(() => import('../pages/simulator/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const CountriesPage = lazy(() => import('../pages/countries/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const CompliancePage = lazy(() => import('../pages/compliance/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/quienes-somos',
    element: <AboutPage />,
  },
  {
    path: '/servicios',
    element: <ServicesPage />,
  },
  {
    path: '/simulador',
    element: <SimulatorPage />,
  },
  {
    path: '/solicitar-credito',
    element: <ApplyPage />,
  },
  {
    path: '/registro',
    element: <RegisterPage />,
  },
  {
    path: '/iniciar-sesion',
    element: <LoginPage />,
  },
  {
    path: '/panel-cliente',
    element: <DashboardPage />,
  },
  {
    path: '/paises',
    element: <CountriesPage />,
  },
  {
    path: '/aviso-privacidad',
    element: <PrivacyPage />,
  },
  {
    path: '/terminos-condiciones',
    element: <TermsPage />,
  },
  {
    path: '/cumplimiento-legal',
    element: <CompliancePage />,
  },
  {
    path: '/contacto',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
